import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { DotsThreeOutline, Buildings, Gear, X } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { DEPARTMENTS } from "@/constants";
import { navItems } from "@/components/Layout/Sidebar";

export const BottomNav = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);

  return (
    <>
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-card border-t border-border flex items-stretch h-16" data-testid="bottom-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            data-testid={`bottom-nav-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
            className={({ isActive }) => `flex-1 flex flex-col items-center justify-center gap-1 text-[10px] font-medium ${isActive ? "text-primary" : "text-muted-foreground"}`}
          >
            <item.icon size={20} weight="regular" />
            {item.label === "Gantt Chart" ? "Gantt" : item.label}
          </NavLink>
        ))}
        <button
          data-testid="bottom-nav-more-btn"
          onClick={() => setMoreOpen(true)}
          className="flex-1 flex flex-col items-center justify-center gap-1 text-[10px] font-medium text-muted-foreground"
        >
          <DotsThreeOutline size={20} weight="regular" />
          More
        </button>
      </nav>

      {moreOpen && (
        <div className="md:hidden fixed inset-0 z-40 bg-black/40" data-testid="bottom-nav-more-sheet" onClick={() => setMoreOpen(false)}>
          <div className="absolute bottom-0 inset-x-0 bg-card border-t border-border p-4 space-y-1" onClick={(e) => e.stopPropagation()} style={{ borderRadius: "12px 12px 0 0" }}>
            <div className="flex items-center justify-between mb-2">
              <span className="label-caps">Departments &amp; Admin</span>
              <button data-testid="bottom-nav-more-close" onClick={() => setMoreOpen(false)}><X size={18} /></button>
            </div>
            {DEPARTMENTS.map((dept) => (
              <button
                key={dept}
                data-testid={`bottom-nav-more-dept-${dept.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => { navigate(`/departments/${encodeURIComponent(dept)}`); setMoreOpen(false); }}
                className="side-link w-full text-left"
              >
                <Buildings size={16} weight="regular" />
                {dept}
              </button>
            ))}
            {user?.role === "admin" && (
              <button
                data-testid="bottom-nav-more-settings"
                onClick={() => { navigate("/settings"); setMoreOpen(false); }}
                className="side-link w-full text-left"
              >
                <Gear size={16} weight="regular" />
                Settings
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};
